import { useEffect } from 'react';

import { getIPLocation } from '../apollo/graphql/get_ip_location.query';

const UNKNOWN_STATE = 'unknown';

export const useGetIPLocation = (clientIP: string | undefined) => {
  useEffect(() => {
    const getLocation = async () => {
      if (typeof sessionStorage !== 'undefined') {
        const ipState = sessionStorage.getItem('ipState');
        if (!ipState) {
          const ipLocation = await getIPLocation(clientIP);
          sessionStorage.setItem('ipState', ipLocation?.state || UNKNOWN_STATE);
        }
      }
    };
    void getLocation();
  }, [clientIP]);
};

/**
 * Get the IP state from session storage
 */
export function getIPState(): string | null {
  if (typeof sessionStorage !== 'undefined') {
    const ipState = sessionStorage.getItem('ipState');
    if (ipState === UNKNOWN_STATE) {
      return null;
    }
    return ipState;
  }
  return null;
}
